import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 4h-4v16h4","key":"svg-0"}],["path",{"d":"M17 4h4v16h-4","key":"svg-1"}],["path",{"d":"M8 16h.01","key":"svg-2"}],["path",{"d":"M12 16h.01","key":"svg-3"}],["path",{"d":"M16 16h.01","key":"svg-4"}]]

const IconBracketsContain = createReactComponent('outline', 'brackets-contain', 'BracketsContain', __iconNode);

export default IconBracketsContain;